// extracted by mini-css-extract-plugin
export default {"container":"MainPage_container__iwHhW","container_big":"MainPage_container_big__ELHPa","loader":"MainPage_loader__zkdh8","loaderAnim":"MainPage_loaderAnim__uv3X7"};